import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import s from './dre.scss';
// Just triggering a full build...
const DRE = ({ environment, dre })=>{
    var _dre, _dre1, _dre2, _dre3, _dre4, _dre5, _dre6, _dre7, _dre8, _dre9, _dre10, _dre11, _dre12, _dre13;
    const [appInfo, updateAppInfo] = useState('n/a');
    useEffect(()=>{
        updateAppInfo(window['__APP_INFO__']);
    }, []);
    const url = Url.buildFromPath(`dre/share?dumpid=${(_dre = dre) === null || _dre === void 0 ? void 0 : _dre.dumpId}&token=${(_dre1 = dre) === null || _dre1 === void 0 ? void 0 : _dre1.dumptoken}`, 'https://admin.deviantart.com/');
    const openWindow = ()=>{
        const win = window.open(url, 'DRE_Console', `left=100,top=225,width=${Math.round(document.body.offsetWidth * 0.8)},height=${Math.round(screen.height * 0.7)},toolbar = 0, scrollbars = 1, location = 0, status = 0, statusmenubar = 0, resizable = 1`);
        if (!win) {
            return alert('DRE window has been blocked as a popup');
        }
        win.focus();
    };
    const wrapEvent = (eventCount, label)=>{
        if (!eventCount) {
            return `0${label}`;
        }
        return /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("strong", null, eventCount), label);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], ((_dre2 = dre) === null || _dre2 === void 0 ? void 0 : _dre2.alarmEvents) && ((_dre3 = dre) === null || _dre3 === void 0 ? void 0 : _dre3.alarmEvents) > 0 && s['alert']),
        onClick: openWindow
    }, (_dre4 = dre) === null || _dre4 === void 0 ? void 0 : _dre4.hostname, " ", (_dre5 = dre) === null || _dre5 === void 0 ? void 0 : _dre5.totaltime, "ms ", /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("span", {
        className: s['alarms']
    }, wrapEvent((_dre6 = dre) === null || _dre6 === void 0 ? void 0 : _dre6.alarmEvents, 'A')), ' ', wrapEvent((_dre7 = dre) === null || _dre7 === void 0 ? void 0 : _dre7.warningEvents, 'W'), " ", wrapEvent((_dre8 = dre) === null || _dre8 === void 0 ? void 0 : _dre8.noticeEvents, 'N'), ' ', ((_dre9 = dre) === null || _dre9 === void 0 ? void 0 : _dre9.myEvents) && wrapEvent((_dre10 = dre) === null || _dre10 === void 0 ? void 0 : _dre10.myEvents, 'M'), ' ', ((_dre11 = dre) === null || _dre11 === void 0 ? void 0 : _dre11.quickEvents) && wrapEvent((_dre12 = dre) === null || _dre12 === void 0 ? void 0 : _dre12.quickEvents, 'Q'), ' ', wrapEvent((_dre13 = dre) === null || _dre13 === void 0 ? void 0 : _dre13.infoEvents, 'T'), /*#__PURE__*/ React.createElement("div", null, appInfo));
};
DRE.displayName = 'DRE';
export default DRE;
